import flagBr from "../../assets/images/flags/br.svg";
import flagUs from "../../assets/images/flags/us.svg";
import flagEs from "../../assets/images/flags/es.svg";

export const LANGUAGE_OPTIONS = [
	{ code: "pt-BR", labelKey: "languages.pt-BR", flag: flagBr, flagAlt: "Brasil" },
	{ code: "en", labelKey: "languages.en", flag: flagUs, flagAlt: "English" },
	{ code: "es", labelKey: "languages.es", flag: flagEs, flagAlt: "Español" },
];

export function getLanguageOption(code) {
	return LANGUAGE_OPTIONS.find((l) => l.code === code) || LANGUAGE_OPTIONS[0];
}
